/**
 * @class {T.Form.Input}
 * @extends {T.Form.Base}
 * @param {T.Form.Input.Par|Object} [par]
 */
T.Form.Input = Class(
	/**
	 * @lends {T.Form.Input#}
	 */
	{
		__NAME: 'T.Form.Input',

		/**
		 * @param {T.Form.Input.Par|Object} [par]
		 * @constructs
		 */
		__construct: function(par){
			par = par || {};
			let attr = {
				placeholder: par.placeholder || ''
			};
			O2O(attr, par.attr || {});

			this._onChangeEvent = par.onChange || D.doNothing;
			this._onKeyUpEvent = par.onKeyUp || D.doNothing;
			this._onKeyDownEvent = par.onKeyDown || D.doNothing;
			this._onFocusEvent = par.onFocus;
			this._onBlurEvent = par.onBlur;

			this.node = mkE({
				tag: 'div',
				className: 'input',
				els: [
					this._captionNode = mkE({
						tag: 'label',
						className: 'hidden'
					}),
					this._itemNode = mkE({
						tag: 'div',
						className: 'form-control',
						els: [
							this._input = mkE({
								tag: 'input',
								type: par.type || 'text',
								attr: attr,
								prop: {
									onchange: this._onChange,
									onkeyup: this._onKeyUp,
									onkeydown: this._onKeyDown,
									onfocus: this._onFocus,
									onblur: this._onBlur
								}
							})
						]
					}),
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.border ){
				addClassName(this.node, 'input-border');
			}

			if( par.dark ){
				addClassName(this.node, 'input-dark');
			}

			if( par.icon ){
				addClassName(this.node, 'input-icon input-icon-' + par.icon);
			}

			if( par.className ){
				addClassName(this.node, par.className);
			}

			if( par.clear ){
				this._clearNode = mkE({
					tag: 'div',
					className: 'clear',
					onmousedown: this._clear
				}).append(this._itemNode);
				addClassName(this.node, 'input-clear');
			}

			if( par.remove ){
				this._removeNode = mkE({
					tag: 'div',
					className: 'remove',
					onclick: par.remove
				}).append(this._itemNode);
				addClassName(this.node, 'input-remove');
			}

			this._par(par);
			this.value(par.value || null);
		},

		value: function(v){
			if( isset(v) ){
				this._input.value = v;
			}
			return this._input.value;
		},

		focus: function(){
			this._input.focus();
		},

		blur: function(){
			this._input.blur();
		},

		_onFocus: function(){
			addClassName(this.node, 'input-focus');
			if( this._onFocusEvent ){
				this._onFocusEvent(this);
			}
		},

		_onBlur: function(){
			removeClassName(this.node, 'input-focus');
			if( this._onBlurEvent ){
				this._onBlurEvent(this);
			}
		},

		_clear: function(){
			this.value('');
			setTimeout(this.focus, 100);
			this._checkClear();
		},

		_checkClear: function(){
			if( !this._clearNode ){
				return;
			}
			if( this._input.value ){
				addClassName(this.node, 'input-clear-visible');
			}else{
				removeClassName(this.node, 'input-clear-visible');
			}
		},

		_onChange: function(e){
			this._onChangeEvent(e);
			this._checkClear();
		},

		_onKeyUp: function(e){
			this._onKeyUpEvent(e);
			this._checkClear();
		},

		_onKeyDown: function(e){
			this._onKeyDownEvent(e);
			this._checkClear();
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.Input.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.Input.Par = Class(
	/**
	 * @lends {T.Form.Input.Par#}
	 */
	{
		__NAME: 'T.Form.Input.Par',

		type: 'text',
		placeholder: '',
		prefix: null,
		suffix: null,
		value: null,
		attr: {},
		prop: {},
		onKeyUp: D.doNothing,
		onKeyDown: D.doNothing,
		onChange: D.doNothing,
		border: false,
		dark: false,
		icon: '',
		className: '',
		clear: false
	},
	T.Form.Base.Par
);
